import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatCardModule } from '@angular/material/card'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { IndividualClientService } from '../../../core/services/customer/individual-client/individual-client.service'
import { NgxMaskDirective } from 'ngx-mask'
import { PersonLegalService } from '../../../core/services/person/person-legal/person-legal.service'
import { MatSlideToggleChange } from '@angular/material/slide-toggle'
import { convertCurrency } from '../../../shared/utils/utils'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { cnpjValidator } from '../../../shared/utils/cnpj_validator'
import { AssociateClientCreateComponent } from '../sub-client/associate-client/associate-client-create/associate-client-create.component'
import { ClientService } from '../../../core/services/customer/client/client.service'

@Component({
  selector: 'subclient-convert-client',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInput,
    MatDividerModule,
    NgxMaskDirective,
    AssociateClientCreateComponent,
  ],
  templateUrl: './subclient-convert-client.component.html',
  styleUrl: './subclient-convert-client.component.scss',
  providers: [
    PersonLegalService,
    IndividualClientService,
    CommissionDividerService,
  ],
  standalone: true,
})
export class SubclientConvertClientComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private legalEntityClientService: LegalEntityClientService,
    private commissionDividerService: CommissionDividerService,
    private snackbar: SnackbarCustomService,
    private clientService: ClientService,
    private dialogRef: MatDialogRef<SubclientConvertClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    this.commissionDividerClient = {
      idCLient: this.item.isCLient,
      taxa: this.item.taxa ?? 0,
      divisor: this.item.divisor ?? 0,
      comissao: this.item.comissao ?? 0,
    }
    if (data.type == 'legal-entity-client') {
      this.listTypeClient.push({ id: 'legal', description: 'Pessoa Jurídica' })
    } else if (data.type == 'individual-client') {
      this.listTypeClient.push({
        id: 'individual',
        description: 'Pessoa Fisica',
      })
    }
  }

  @Output() response = new EventEmitter()

  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    // { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  typeClient: 'legal' | 'individual' = 'legal'

  item: any
  loading: boolean = false
  loadingScreen: boolean = true

  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  commissionDividerClient: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  panelAdress: boolean = false
  panelContact: boolean = false
  panelResponsable: boolean = false
  panelFinancial: boolean = false
  panelBankDetails: boolean = false
  panelSubClient: boolean = false

  clientList: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.getCommissionDivider()
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      name: [this.item.nomeFantasia, [Validators.required]],
      cnpj: [this.item.cnpj, [Validators.required, cnpjValidator()]],
      corporate_name: [this.item.razaoSocial, [Validators.required]],
      reg_state: [this.item.inscricaoEstadual],
      reg_municipal: [this.item.inscricaoMunicipal],
    })
    this.formIndividual = this.formBuilder.group({
      name: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
    })
    this.formFinancial = this.formBuilder.group({
      tgmob: [true],
      tax: [''],
      commission: [''],
      divider: [''],
    })
    this.checkDivider()
    this.loadingScreen = false
  }

  checkDivider() {
    if (this.item.divisorId) {
      this.formFinancial.get('tgmob')!.setValue(false)
      this.fillFormFinancial(true)
    } else {
      this.fillFormFinancial()
    }
  }

  checkInvalidForm() {
    if (!this.loading) {
      return true
    } else {
      return false
    }
  }

  editLegalModel() {
    return {
      subclienteId: this.item.id,
      // cliewntes: this.clientList,
    }

    // return {
    //   id: this.item.pessoaJuridicaId,
    //   pessoaId: this.item.pessoaId,
    //   razaoSocial: this.formLegalEntity.get('corporate_name')?.value ?? '',
    //   cnpj: this.formLegalEntity.get('cnpj')?.value ?? '',
    //   nomeFantasia: this.formLegalEntity.get('name')?.value ?? '',
    //   inscricaoEstadual: this.formLegalEntity.get('reg_state')?.value ?? '',
    //   inscricaoMunicipal:
    //     this.formLegalEntity.get('reg_municipal')?.value ?? '',
    //   divisor: {
    //     id: this.item.divisorId,
    //     IsCliente: this.formFinancial.get('tgmob')?.value ? 'N' : 'S',
    //     clienteId: this.item.id,
    //     divisor: convertCurrency(this.formFinancial.get('divider')!.value),
    //     comissao: convertCurrency(this.formFinancial.get('commission')!.value),
    //     taxa: convertCurrency(this.formFinancial.get('tax')!.value),
    //     ativo: 'S',
    //   },
    // }
  }

  editIndividualModel() {
    return {
      nome: this.formLegalEntity.get('name')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
    }
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) {
      this.fillFormFinancial()
    } else {
      this.fillFormFinancial(true)
    }
  }

  fillFormFinancial(clear: boolean = false) {
    if (!clear) {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')!.disable()
      this.formFinancial.get('tax')!.disable()
      this.formFinancial.get('commission')!.disable()
    } else {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDividerClient.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDividerClient.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDividerClient.comissao))
      this.formFinancial.get('divider')!.enable()
      this.formFinancial.get('tax')!.enable()
      this.formFinancial.get('commission')!.enable()
    }
  }

  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa:
            response && response.data && response.data.taxa
              ? response.data.taxa
              : 0,
          divisor:
            response && response.data && response.data.divisor
              ? response.data.divisor
              : 1,
          comissao:
            response && response.data && response.data.comissao
              ? response.data.comissao
              : 0,
        }
        // this.commissionDivider = {
        //   taxa: response.data.taxa,
        //   divisor: response.data.divisor,
        //   comissao: response.data.comissao,
        // }
        this.checkDivider()
      },
      error: (err: ErrorRequestModel) => {
        console.error('err', err)
      },
      complete: () => {},
    })
  }

  // editClient() {
  //   this.loading = true
  //   if (this.typeClient == 'legal') {
  //     this.editClientLegal()
  //   } else if (this.typeClient == 'individual') {
  //     this.editClientIndividual()
  //   } else {
  //     this.snackbar.error('Selecione um tipo de Cliente')
  //   }
  // }

  transformClient() {
    this.loading = true
    this.clientService
      .createSubclientAlsoClient(this.editLegalModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.formLegalEntity.reset()
          this.formFinancial.reset()
        },
      })
  }

  editClientLegal() {
    // this.personLegalService.editPersonLegal(this.editLegalModel()).subscribe({
    this.legalEntityClientService
      .editLegalEntityClient(this.editLegalModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.formLegalEntity.reset()
          this.formFinancial.reset()
        },
      })
  }

  getList(list: any[], typeList: 'client'): void {
    switch (typeList) {
      case 'client':
        this.clientList = list
        break
    }
  }

  editClientIndividual() {
    // this.individualClientService
    //   .createIndividualClient(this.editIndividualModel())
    //   .subscribe({
    //     next: (response: ResponseRequestModel) => {
    //       this.snackbar.success(response.message)
    //       this.response.emit(true)
    //       this.close()
    //     },
    //     error: (err: ResponseRequestModel) => {
    //       this.loading = false
    //       this.snackbar.error(err.error)
    //     },
    //     complete: () => {
    //       this.loading = false
    //       this.formIndividual.reset()
    //       this.formFinancial.reset()
    //     },
    //   })
  }
}
